import Button from 'shared/Buttons/Button/Button'
import Modal from 'shared/Modal'
import ModalHeader from 'shared/Modal/ModalHeader'
import ProjectStageSheet from '../ProjectStageSheet'
import useStateWithChange from 'shared/hooks/useStateWithChange'
import useHttpLoader from 'shared/hooks/useHttpLoader'
import projectStagesApi from '../../projectStages.api'
import eventBus from 'services/eventBus'
import { IProjectStage } from '../../projectTypes.types'
import { useProjectStagesState } from '../../hooks/useProjectStagesState'

interface IProps {
  onClose: () => void
  projectStage: IProjectStage
}

const ProjectStageModal = (props: IProps) => {

  const [draft, _setState, handleChange] = useStateWithChange(props.projectStage)

  const { wait, loading } = useHttpLoader()

  const { updateItem } = useProjectStagesState()

  const handleSave = () => {
    wait(projectStagesApi.update(draft, props.projectStage.id), (resp) => {
      if (resp.status === 'success') {
        updateItem(resp.body)
        props.onClose()
        eventBus.pub('ntf.message', { message: 'Этап проекта успешно обновлен', type: 'info' })
      }
    })
  }

  const isValid = draft.name && draft.checkpoints.length > 0

  return (
    <Modal onClose={props.onClose} size='hg' shouldAnimate={false}>
      <ModalHeader onClose={props.onClose}>Создание этапа проекта</ModalHeader>
      <div className='modal-content flex-lines' style={{ height: '60vh' }}>
        <ProjectStageSheet onChange={handleChange} projectStage={draft} />
      </div>
      <div className='modal-footer'>
        <Button theme='grey-outline' style={{ width: 'fit-content' }} onClick={props.onClose}>
          Отмена
        </Button>
        <Button
          disabled={!isValid}
          theme='primary'
          style={{ width: 'fit-content' }}
          onClick={handleSave}
          loading={loading}
        >
          Сохранить
        </Button>
      </div>
    </Modal>
  )
}

export default ProjectStageModal
